import { createSubmittedFormPhotoUploadParams, performFileUpload } from '@components/utils/fileupload';
import { requestUploadSlotV2 } from '@helpers/file-upload-helpers';

export const imageAnnotationSave = async ({ pageData, formID = 0, hash = "", onProgress = () => {} }) => {
    const xhr = new XMLHttpRequest();
    const outImage = {};

    for (const pageId in pageData) {
        const result = await retryUpload(pageId, pageData, formID, hash, xhr, onProgress);
        if (result) outImage[pageId] = result;
    }

    return outImage;
};

const retryUpload = async (pageId, pageData, formID, hash, xhr, onProgress) => {
    while (true) {
        const result = await submitUpload(pageId, pageData, formID, hash, xhr, onProgress);
        if (result) return result;
        if (!confirm("Failed to upload, retry?")) break;
    }
    return null;
};

const submitUpload = async (pageId, pageData, formID, hash, xhr, onProgress) => {
    const { meta, imageData } = pageData[pageId];
    const fileName = `annotate.${meta.fileName}`;
    const file = new File([imageData], fileName, { type: imageData.type });
    const uploadParams = {
        ...createSubmittedFormPhotoUploadParams({ formID, hash }),
        fileName,
        extra: {},
    };

    try {
        const uploadSlot = await requestUploadSlotV2(window.location.toString(), uploadParams);
        await performFileUpload(xhr, file, uploadSlot.url, uploadSlot.fields, (e) => onProgress(pageId, e));
        return { file: uploadSlot.fileName, meta };
    } catch {
        return null;
    }
};
